<template>
  <section class="dash-section" aria-labelledby="dash-activity-heading">
    <div class="dash-section__head">
      <div>
        <h2 id="dash-activity-heading" class="dash-section__title">Daily Activity</h2>
        <p class="dash-section__subtitle">{{ rows.length }} days in selected period</p>
      </div>
    </div>

    <div v-if="loading" class="dash-activity dash-activity--skeleton">
      <div v-for="n in 5" :key="n" class="dash-activity-row dash-activity-row--skeleton" />
    </div>

    <div v-else-if="rows.length" class="dash-activity" role="list">
      <article
        v-for="row in rows"
        :key="row.date"
        class="dash-activity-row"
        role="listitem"
      >
        <div class="dash-activity-row__date">
          <v-icon icon="mdi-calendar-blank-outline" size="18" />
          <span>{{ formatDate(row.date) }}</span>
        </div>
        <div class="dash-activity-row__stat">
          <span class="dash-activity-row__label">Calls</span>
          <span class="dash-activity-row__value">{{ formatNumber(row.total_calls) }}</span>
        </div>
        <div class="dash-activity-row__stat">
          <span class="dash-activity-row__label">Duration</span>
          <span class="dash-activity-row__value">{{ formatDuration(row.total_call_seconds) }}</span>
        </div>
        <div class="dash-activity-row__stat">
          <span class="dash-activity-row__label">Cost</span>
          <span class="dash-activity-row__value">{{ formatCost(row.total_cost) }}</span>
        </div>
        <div
          class="dash-activity-row__trend"
          :class="`dash-activity-row__trend--${row.trend}`"
        >
          <v-icon
            :icon="trendIcon(row.trend)"
            size="16"
          />
        </div>
      </article>
    </div>

    <p v-else class="dash-empty">No daily activity recorded for this period.</p>
  </section>
</template>

<script setup>
import { formatCallDuration, formatCost, formatIsoDate, formatNumber } from '@/utils/format'

defineOptions({ name: 'DashboardActivityList' })

defineProps({
  rows: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
})

function formatDate(value) {
  return formatIsoDate(value)
}

function formatDuration(value) {
  return formatCallDuration(value)
}

function trendIcon(trend) {
  if (trend === 'up') return 'mdi-trending-up'
  if (trend === 'down') return 'mdi-trending-down'
  return 'mdi-minus'
}
</script>
